<template>
    <div class="footer">
       <div>让渠道更易搜，让合作更放心</div>
       <div>合作热线：133-3288-8870 / 132-8881-0072</div>
    </div>
</template>

<script>
export default{
    name:'CommonTag',
    data(){
        return {}
    },
    computed:{

    },
    methods:{

       
    }
}
</script>
<style lang="less" scoped>
.footer{
    background-color: #333;
    height: 6em;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 1em;
}
</style>